import React from 'react'

import { H1 } from '@driftt/tide-core'

import installVideoThumbnailSrc from './../assets/install-video-thumbnail.jpg'
import { InstallButton } from './../index'

const MarketingInstallVariant = ({ onInstallClick }) => {
  const surveyResponse =
    !!localStorage.getItem('video_survey_completed') &&
    localStorage.getItem('video_survey_completed') !== 'skipped' &&
    localStorage.getItem('video_survey_completed') !== 'true' &&
    localStorage.getItem('video_survey_completed').indexOf('Other') === -1 &&
    localStorage.getItem('video_survey_completed')

  return (
    <div>
      <div className="drift-install-education-container">
        <a
          href="https://video.drift.com/v/ab66nw5tj0o/"
          target="_blank"
          rel="noopener noreferrer"
          className="drift-install-video"
        >
          <img src={installVideoThumbnailSrc} alt="welcome video thumbnail" />
        </a>
        <div className="drift-install-section-header">
          <H1 className="drift-getting-started-title">
            {surveyResponse
              ? `Awesome - lots of people are using Drift Video for ${surveyResponse}!`
              : "Awesome! Let's get you set up:"}
            <br />
            <span>
              Install the Chrome Extension to start recording videos, too.
            </span>
          </H1>
        </div>
        <InstallButton
          onInstallClick={onInstallClick}
          copy="Install Drift Video"
          showArrow={true}
        />
      </div>
    </div>
  )
}

export default MarketingInstallVariant
